export const baseSize = 16
export const baseWidth = 1920

// 设置 rem 函数

export function setRem() {
  // 当前页面宽度相对于 750 宽的缩放比例，可根据自己需要修改。
  const scale = document.documentElement.clientWidth / baseWidth
  // 设置页面根节点字体大小
  document.documentElement.style.fontSize = (baseSize * Math.min(scale, 5)) + 'px'
}

export function getFontSize() {
  // 当前页面宽度相对于 750 宽的缩放比例，可根据自己需要修改。
  const scale = document.documentElement.clientWidth / baseWidth
  // 设置页面根节点字体大小
  return (baseSize * Math.min(scale, 5))
}

